import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { hash } from '@ember/helper';
import ChartResizerSentinel from '@linc-technologies/linced-common/components/chart-resizer-sentinel';

interface ChartResizerSignature {
  Args: {
    // ratio gives the height as a fraction of the width.
    ratio?: number;
    // maxHeight limits the height. 0 sets no limit.
    maxHeight?: number;
  };
  Blocks: {
    default: [{ width: number; height: number; viewBox: string }];
  };
}

export default class ChartResizer extends Component<ChartResizerSignature> {
  @tracked width = 480;

  get height() {
    const height = Math.floor(this.width * (this.args.ratio ?? 0.75));
    const maxHeight = this.args.maxHeight ?? 0;
    return maxHeight > 0 ? Math.min(height, maxHeight) : height;
  }

  get viewBox() {
    // Extend 10 units to the left of the drawn content (rather than shifting
    // the window over it) so left-hand Y-axis labels aren't clipped without
    // losing the same 10 units off the right edge, which clipped X-axis labels.
    return `-10 0 ${this.width + 10} ${this.height}`;
  }

  didResize = (newWidth: number) => {
    this.width = newWidth;
  };

  <template>
    <ChartResizerSentinel
      @didResize={{this.didResize}}
      @previousWidth={{this.width}}
    />

    {{yield (hash width=this.width height=this.height viewBox=this.viewBox)}}
  </template>
}
